module.exports = __webpack_public_path__ + "static/forager-dude-3f3574a1428a328caa1688a753e0b0b5.webp";